export const JOURNAL_PROMPTS = {
  gratitude: [
    "What are 3 small things that brought you joy today?",
    "Who made a positive difference in your life recently? How?",
    "What part of your daily routine are you grateful for?",
    "What challenge helped you grow, and why are you thankful for it?",
    "What simple pleasure did you enjoy today?",
  ],
  reflection: [
    "What emotion has been most present for you today? Why?",
    "If you could tell your morning self one thing, what would it be?",
    "What boundary did you set or wish you had set today?",
    "What's something you learned about yourself this week?",
    "What would make tomorrow feel more manageable?",
  ],
  growth: [
    "What's one small step you took toward a goal today?",
    "What's something you're working on improving? How's it going?",
    "What advice would you give to someone in your situation?",
    "What fear held you back today, and how might you face it?",
    "What would your future self thank you for doing today?",
  ],
  selfCompassion: [
    "What do you need to forgive yourself for today?",
    "How can you be kinder to yourself right now?",
    "What would you say to a friend feeling the way you do?",
    "What's one thing you did well today, even if small?",
    "What does your inner critic say, and how can you respond gently?",
  ],
  anxiety: [
    "What worry is weighing on you? Is it within your control?",
    "What's the worst case scenario, and how would you cope?",
    "What evidence contradicts your anxious thoughts?",
    "What would you do if you weren't afraid?",
    "What's one thing you can do right now to feel more grounded?",
  ],
  grief: [
    "What is one memory of them, or of what you lost, that you want to hold onto?",
    "What do you wish you could say to them right now?",
    "What has grief felt like in your body today?",
    "What is one small thing that brought even a moment of comfort this week?",
    "What would you want a friend going through this loss to hear?",
    "Which days or moments feel hardest, and what might help on those days?",
  ],
  processing: [
    "Describe a moment that stood out today. How did it make you feel?",
    "What's something you're holding onto that you might need to release?",
    "What conversation or interaction is still on your mind?",
    "What did your body tell you today that you might have ignored?",
    "Free write for 5 minutes without stopping. What comes out?",
  ],
};

export const PROMPT_CATEGORIES = [
  { id: 'gratitude', name: 'Gratitude', emoji: '🙏', color: '#4CAF50' },
  { id: 'reflection', name: 'Reflection', emoji: '🪞', color: '#2196F3' },
  { id: 'growth', name: 'Growth', emoji: '🌱', color: '#FF9800' },
  { id: 'selfCompassion', name: 'Self-Care', emoji: '💜', color: '#9C27B0' },
  { id: 'anxiety', name: 'Anxiety', emoji: '🌊', color: '#00BCD4' },
  { id: 'processing', name: 'Process', emoji: '💭', color: '#607D8B' },
  { id: 'grief', name: 'Grief & Loss', emoji: '🕯️', color: '#8D6E63' },
];

export const MOOD_OPTIONS = [
  { emoji: '😊', label: 'Happy' },
  { emoji: '😌', label: 'Calm' },
  { emoji: '😔', label: 'Sad' },
  { emoji: '😰', label: 'Anxious' },
  { emoji: '😤', label: 'Frustrated' },
  { emoji: '😴', label: 'Tired' },
  { emoji: '🤔', label: 'Thoughtful' },
  { emoji: '💪', label: 'Strong' },
  { emoji: '🎉', label: 'Excited' },
];

